import React from "react";
import { MdErrorOutline, MdWarning, MdInfo, MdClose } from "react-icons/md";

import styles from "./ValidationError.module.scss";

interface Props {
  message: string;
  type?: "error" | "warning" | "info";
  showIcon?: boolean;
  onDismiss?: () => void;
}

export const ValidationError: React.FC<Props> = ({
  message,
  type: propType = "error",
  showIcon = true,
  onDismiss,
}) => {
  const getType = (msg: string): "error" | "warning" | "info" => {
    if (msg.includes("бонус") || msg.includes("промокод")) return "warning";
    if (msg.includes("не действует") || msg.includes("нет товаров")) return "info";
    return propType;
  };

  const type = getType(message);

  const Icon =
    type === "warning" ? MdWarning : type === "info" ? MdInfo : MdErrorOutline;

  return (
    <div className={`${styles.Container} ${styles[type]}`}>
      {showIcon && (
        <span className={styles.Icon}>
          <Icon size={18} />
        </span>
      )}

      <p className={styles.Message}>{message}</p>

      {onDismiss && (
        <button
          type="button"
          className={styles.Dismiss}
          onClick={onDismiss}
          aria-label="Закрыть"
        >
          <MdClose size={18} />
        </button>
      )}
    </div>
  );
};